import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {GlobalModule} from "../global/global.module";
import {FinalDecisionRoutingModule} from "./final-decision-routing.module";
import {FinalDecisionComponent} from "./final-decision.component";



@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    FinalDecisionRoutingModule,
    GlobalModule
  ],
  declarations: [
    FinalDecisionComponent
  ]
})
export class FinalDecisionModule { }
